// noinspection ExceptionCaughtLocallyJS

import { setLoading, wrap } from './index';
import { store } from '../index';
import * as constants from '../constants';
import { Dispatch } from 'redux';
import { SchemaGetProductQueryParams } from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const fetchProductByUrn = (params: SchemaGetProductQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      const { data, error } = await legacyApi.GET('/product', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'FETCH_ERROR');

export const fetchProductByUrnWithStateUpdate = (params: SchemaGetProductQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ name: 'mapProduct', value: true }));
      const { data, error } = await legacyApi.GET('/product', { params: { query: params } });
      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_PRODUCT, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading({ name: 'mapProduct', value: false }));
      throw err;
    } finally {
      dispatch(setLoading({ name: 'mapProduct', value: false }));
    }
  }, 'FETCH_ERROR');

export const fetchProducts = (params: SchemaGetProductQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    const storeObj = store.getState();

    try {
      if (storeObj.app?.productsJ2ByUrn && storeObj.app.productsJ2ByUrn[params.urn]) {
        // j2
        const product = storeObj.app.productsJ2ByUrn[params.urn];
        const resData = { data: { ...product } };
        dispatch({ type: constants.FETCHED_PRODUCT, payload: resData });
        return Promise.resolve(resData);
      } else if (
        storeObj.app?.userDataEC?.chosenBasketProducts?.productsByUrn &&
        storeObj.app?.userDataEC?.chosenBasketProducts?.productsByUrn[params.urn]
      ) {
        // j1
        const product = storeObj.app?.userDataEC?.chosenBasketProducts?.productsByUrn[params.urn];
        const resData = { data: { ...product } };
        dispatch({ type: constants.FETCHED_PRODUCT, payload: resData });
        return Promise.resolve(resData);
      } else {
        const { data, error } = await legacyApi.GET('/product', { params: { query: params } });
        if (error) {
          throw JSON.stringify(error);
        }
        dispatch({ type: constants.FETCHED_PRODUCT, payload: data });
        return data;
      }
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'FETCH_ERROR');

export const setDigiflexData = (payload: any) => ({
  type: constants.SET_DIGIFLEX_DATA,
  payload,
});

export const clearDigiflexData = () => ({
  type: constants.CLEAR_DIGIFLEX_DATA,
});
